import M from 'materialize-css';
import Vue from 'vue'

import CalendarDay from './components/CalendarDay.vue';
import CalendarViewToggle from './components/CalendarViewToggle.vue';
import SolveDataTable from './components/DataTable.vue';
import ConstructorSearch from './components/ConstructorSearch.vue';
import ProfileSync from './components/ProfileSync.vue';
import StatsChart from './components/StatsChart.vue';

import './utils/filters';
import eventBus from './events';

import VTooltip from 'v-tooltip'
Vue.use(VTooltip);  // global options here don't seem to work :/

import vSelect from 'vue-select'
Vue.component('v-select', vSelect)

M.AutoInit();
const elems = document.querySelectorAll('.sidenav');
M.Sidenav.init(elems, {});

import * as Sentry from "@sentry/vue";
import { Integrations } from "@sentry/tracing";
Sentry.init({
  Vue,
  dsn: "https://22b8bd7a000743d1a85d5193cb27044c@o526717.ingest.sentry.io/4504161361395712",
	integrations: [new Integrations.BrowserTracing()],
	tracesSampleRate: 0.1,
	logErrors: true,
	denyUrls: [/localhost/i, /127\.0\.0\.1/],
	release: process.env.VUE_APP_RELEASE,
});


const vueConfigDict = {
  components: {
    CalendarDay,
		CalendarViewToggle,
		SolveDataTable,
		ConstructorSearch,
		ProfileSync,
		StatsChart,
  },
  methods: {
		syncAll: function() {
			eventBus.emit('syncAll');
		},
	},
};

export default vueConfigDict;
